import {
  Container,
  Wrapper700,
  SkeletonLoader,
  PaddingTopBottom30,
  ListContent,
  makeArrayFromLength,
} from "oolib";
import React, { Fragment } from "react";
import { TotalCount } from "../../../TotalCount";
import { listingWrapperSelector } from "../../utils/listingWrapperSelector";
import DownloadDataButton from "../../DownloadDataButton";
import { parseSpecialConfigSyntax } from "@okf/ootils";
import { useGetQueryData } from "@/utils/react-query-hooks/general";
import { handleShowUnderEditInfoOnCardOrListItem } from "@/_self_managed/utils/handleShowUnderEditInfoOnCardOrListItem";

const FallbackWrapper = ({ children, enableContainerQuery }) => (
  <div enableContainerQuery={enableContainerQuery}>
    <Wrapper700 left>{children}</Wrapper700>
  </div>
);

const ListStyle = ({
  data,
  status,
  isFetchingNextPage,
  observerRef,
  totalCount,
  configs: configs_,
  onClick,
  ListingWrapper,
  enableContainerQuery,
  inTCI,
  getDataToBeExported,
  linkTo,
}) => {
  const { SELF_MANAGED_BASE_CONFIGS } = useGetQueryData("platformConfigs");

  const Wrapper = listingWrapperSelector({
    ListingWrapper,
    FallbackWrapper,
  });

  const genSkeletonListElems = () =>
    makeArrayFromLength(6).map(() => (
      <SkeletonLoader style={{ height: "13rem", margin: "1rem 0" }} />
    ));

  const genListElems = (data) =>
    data?.map((d_, i) => {
      let d = d_; 
      let configs = configs_; 
      let pluginExtraProps = {};
      if (
        SELF_MANAGED_BASE_CONFIGS?.listingConfig
          ?.showUnderEditInfoOnCardOrListItem === true
      ) {
        const {
          config: editedConfig,
          content: editedContent,
          extraProps = {},
        } = handleShowUnderEditInfoOnCardOrListItem({
          content: d_,
          config: configs_,
        });
        d = editedContent;
        configs = editedConfig;
        pluginExtraProps = {
          ...extraProps,
        };
      }

      //read in the function what paeseSpecialConfigSyntax does. if there is no special config, it will return the link string as is.
      let cardLinkUrl = onClick //onClick overrides to, cuz both cant exist at same time
        ? undefined
        : linkTo && parseSpecialConfigSyntax({ config: linkTo, content: d });

      return (
        <Fragment key={d._id}>
          <div key={d._id} ref={data.length === i + 1 ? observerRef : null}>
            <ListContent
              id={d._id}
              data={d}
              to={cardLinkUrl}
              config={configs}
              onClick={onClick}
              {...(pluginExtraProps || {})}
            />
          </div>
        </Fragment>
      );
    });

  return (
    <div>
      <Wrapper enableContainerQuery={enableContainerQuery}>
        <div
          style={{
            display: "flex",
            gap: "0.5rem",
            paddingBottom: "1rem",
          }}
        >
          {totalCount !== undefined && (
            <TotalCount
              style={{ paddingBottom: "2rem" }}
              totalCount={totalCount}
            />
          )}
          {getDataToBeExported && (
            <>
              <DownloadDataButton getDataToBeExported={getDataToBeExported} />
            </>
          )}
        </div>

        {/* <PaddingTopBottom30> */}
        {status === "loading" ? genSkeletonListElems() : genListElems(data)}
        {isFetchingNextPage && genSkeletonListElems()}
        {/* </PaddingTopBottom30> */}
      </Wrapper>
    </div>
  );
};

export default ListStyle;
